import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/jensen'

Styxie.Initializers.JensenTelephonyAccounts = {
  index: async(props) => {
    const { default: TelephonyAccountsIndex } = await import('@/vue_widgets/jensen/telephony_accounts/index.vue')
    createVueApp(TelephonyAccountsIndex, { props, sidebar })
  },
  new: async(props) => {
    const { default: TelephonyAccountsForm } = await import('@/vue_widgets/jensen/telephony_accounts/form.vue')
    createVueApp(TelephonyAccountsForm, { props, sidebar })
  },
  edit: async(props) => {
    const { default: TelephonyAccountsForm } = await import('@/vue_widgets/jensen/telephony_accounts/form.vue')
    createVueApp(TelephonyAccountsForm, { props, sidebar })
  }
}
